import React from "react";
import { Button } from "@mui/material";
import { tokens } from "../theme";

/**
 * The one marigold button on a screen.
 *
 * The module-screens book names the only three places it may appear in the
 * whole product: submitting a timesheet, approving a batch of claims, and
 * running payroll. All three commit something on other people's behalf and
 * none of them can be quietly undone, which is the whole reason the colour is
 * rationed — a marigold control that appears twice stops meaning "this is the
 * irreversible one".
 *
 * It is a separate component rather than a prop on <PrimaryButton> so that the
 * three call sites can be counted by grepping for the import, and so nobody
 * reaches marigold by passing a colour.
 */
const CommitButton = ({ onClick, disabled, children, sx, type }) => (
  <Button
    type={type}
    onClick={onClick}
    disabled={disabled}
    sx={{
      background: tokens.marigold,
      color: tokens.onMarigold,
      fontSize: "0.875rem",
      lineHeight: 1.6,
      fontWeight: 600,
      whiteSpace: "nowrap",
      textTransform: "none",
      boxShadow: "none",
      "&:hover": { background: tokens.marigoldHover, boxShadow: "none" },
      "&.Mui-disabled": { background: tokens.border, color: tokens.textDisabled },
      ...sx,
    }}
  >
    {children}
  </Button>
);

export default CommitButton;
